
import React, { useState, useContext, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";
import AuthContext from "../../context/auth/authContext";
import {toast} from 'react-toastify';

const AddContactNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { _id } = location.state || {}; // Retrieve _id from location state

  const adminInterestContext = useContext(AdminInterestContext);
  const { addNotes } = adminInterestContext;
  const authContext = useContext(AuthContext);
  const { user } = authContext || {};


  const [formData, setFormData] = useState({
    Username: "",
    email: "",
    notes: "",
    interestId: _id, // Include _id from location state in formData
  });

  const [errors, setErrors] = useState({});
  const { Username, email, notes } = formData;

  // Effect to set initial form data when user is available
  useEffect(() => {
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        Username: user.name || "",
        email: user.azureID || "",
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Validation checks
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Please enter a valid email address.",
        }));
      } else {
        setErrors((prevErrors) => {
          const { email, ...rest } = prevErrors;
          return rest;
        });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Check for errors before submitting
    if (Object.keys(errors).length === 0) {
      // Call the context function to add notes
      try {
        addNotes(formData);
        toast.success("Note Added Successfully");
       // alert("Note Added Successfully");
        navigate(-1);
      } catch (error) {
        console.error("Error adding contact note", error.message);
      }
    } else {
      console.error("Validation errors", errors);
    }

    // Reset form after submission
    setFormData({
      Username: user?.name || "",
      email: user?.azureID || "",
      notes: "",
      interestId: _id, // Reset interestId with the passed _id
    });
  };

  return (
    <div>
      <h1 className="top-title text-center">Add Contact Note</h1>
      <div className="top-container">
        <div
          className="right display-back"
          style={{ fontSize: "18px" }}
          onClick={() => {
            navigate(-1);
          }}
        >
          <FaIcons.FaArrowAltCircleLeft className="back-icon" />
          <h4>Back</h4>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="form">
        <div id="interest-form-page">
          <div className="sub-forms">
            <div className="sub-form">
              <div className="form-group">
                <label htmlFor="Username">Name:</label>
                <input
                  type="text"
                  id="Username"
                  name="Username"
                  value={Username}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
                {errors.email && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errors.email}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="notes">Notes:</label>
                <textarea
                  id="notes"
                  name="notes"
                  value={notes}
                  onChange={handleChange}
                  required
                  className="form-control"
                  style={{ width: "100%", height: "150px", resize: "vertical" }}
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn btn-green"
                style={{ width: "100%" }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddContactNote;

